import React from "react";
import "./styles.css";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";

/**
 * import Swiper styles
 */
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";

// Import Swiper React components
import { Autoplay, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "../Global.js";

const strapiServerUrl = window.strapiServerUrl;

export default function ImageSlide({ slides }) {
  const images = slides;  
  const handleClick = (section) => {
    ReactGA.event({
      category: 'ServiceButton',
      action: 'Click',
      label: `${section}`,
    });
  };


  return (
    <div className="carousel-container">
      <Swiper
        effect="slide"
        loop={true}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Navigation, Autoplay]}
        navigation
        watchSlidesProgress={true}
        className="mySwiper"
      >
        {images.map((image, index) => (
          <SwiperSlide
            key={index}
            style={image.color && { backgroundColor: image.color }}
          >
            <Link to={`/services/details`} state={{ sectionId: image.name }} onClick={() => handleClick(image.name)}>
              <img src={`${strapiServerUrl}${image.image}`} alt="slide" />
            </Link>
            <div className="service_name-container"> 
              <h2>{image.name}</h2>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

